<template>
  <data-table min-width="940px" class="ai-visibility-questions-table">
    <template #head>
      <div class="ai-visibility-questions-table__sort-note">
        Sorted by biggest opportunity first - questions you're missing from appear at the top.
      </div>
      <data-table-row header>
        <data-table-cell header width="490px">Question</data-table-cell>
        <data-table-cell header width="240px" align="center">Are you in the answer?</data-table-cell>
        <data-table-cell header width="240px" align="center">Your visibility score</data-table-cell>
        <data-table-cell header width="160px" align="center">Your rank</data-table-cell>
        <data-table-cell header width="90px" align="center">Action</data-table-cell>
      </data-table-row>
    </template>
    <template #body>
      <template v-if="rows.length">
        <question-table-row
            v-for="(row, index) in rows"
            :key="row.questionId"
            :row="row"
            :index="index"
            :index-offset="indexOffset"
            @select-question="$emit('select-question', $event)"
            @stage-remove-question="$emit('stage-remove-question', $event)"
            @undo-remove-question="$emit('undo-remove-question', $event)"
            @remove-pending-question="$emit('remove-pending-question', $event)"
        />
      </template>
      <div v-else class="ai-visibility-questions-table__empty">
        <empty-state
            title="No questions found"
            description="Try a different filter or search."
        />
      </div>
    </template>
    <template #footer>
      <div class="ai-visibility-questions-table__footer">
        <span>{{ paginationSummary }}</span>
        <table-pagination
            v-if="pageCount > 1"
            :page="page"
            :page-count="pageCount"
            @input="$emit('update:page', $event)"
        />
      </div>
    </template>
  </data-table>
</template>

<script>
import DataTable from '../../../ui/table/DataTable.vue'
import DataTableRow from '../../../ui/table/DataTableRow.vue'
import DataTableCell from '../../../ui/table/DataTableCell.vue'
import TablePagination from '../../../ui/table/TablePagination.vue'
import EmptyState from '../../../ui/states/EmptyState.vue'
import QuestionTableRow from './QuestionTableRow.vue'

export default {
  name: 'QuestionsTable',
  components: {
    DataTable,
    DataTableRow,
    DataTableCell,
    TablePagination,
    EmptyState,
    QuestionTableRow,
  },
  props: {
    rows: {
      type: Array,
      required: true,
    },
    paginationSummary: {
      type: String,
      default: '',
    },
    page: {
      type: Number,
      default: 1,
    },
    pageCount: {
      type: Number,
      default: 1,
    },
    indexOffset: {
      type: Number,
      default: 0,
    },
  },
}
</script>

<style lang="scss" scoped>

::v-deep .ai-visibility-data-table__table {
  padding-top: 0;
}

.ai-visibility-questions-table {
  overflow: hidden;
  border: 1px solid var(--v-gray13Color-base);
  border-radius: 8px;

  ::v-deep .ai-visibility-data-table-row--header {

    &::after {
      border-bottom: 1px dashed var(--v-gray12Color-base) !important;
    }

    .ai-visibility-data-table-cell {
      font-size: 18px;
      font-weight: 500;
    }
  }
}

.ai-visibility-questions-table__sort-note {
  padding: 10px 20px;
  background: rgba(255, 87, 0, 0.10);
  color: var(--v-mainColor3-base);
  font-size: 14px;
  line-height: 1.4;
  overflow-wrap: anywhere;

}

.ai-visibility-questions-table__empty {
  padding: 24px;
}

.ai-visibility-questions-table__footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.ai-visibility-questions-table__footer > span {
  color: var(--v-mainColor-base);
  font-size: 14px;
}

.ai-visibility-questions-table__footer ::v-deep .ai-visibility-table-pagination {
  padding: 0;
}

@media (max-width: 760px) {
  .ai-visibility-questions-table__footer {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
